module.exports = __webpack_public_path__ + "img/aztec_1248.359cb151.png";